import * as React from "react";
import EdButton from "../../generic/edButton";
import RadioButton from "../../generic/radioButton";
import "../../../assets/scss/components/login/forms/mergeIdForm.scss";
import "../../../assets/scss/components/login/generic/loginInput.scss";
import { getPreLoginData, getAccData } from "../../service/login/loginService";
import { IMergeRequest } from "../../types/components/login/loginTypes";

export interface IMergeIdFormProps {
	disableForm: boolean; // used to disable/enable form from parent
	requestMerge: (body: IMergeRequest) => void; // function to be called when request merge button is clicked
	remindLater: () => void; // function to be called when remind later button is clicked
}

const MergeIdForm: React.FC<IMergeIdFormProps> = (props) => {
	// get the merge acc details stored in DataService
	// this has the arrays of uids, phNos and emIds
	const mrgAccDts = getAccData("mrgAccDts");

	// used to store the values of all the fields
	const [mrgUid, setMrgUid] = React.useState<React.ReactText>(getPreLoginData("userID"));
	const [mrgPhNo, setMrgPhNo] = React.useState<React.ReactText>(mrgAccDts.phNos[0]);
	const [mrgEml, setMrgEml] = React.useState<React.ReactText>(mrgAccDts.emIds[0]);

	function handleSubmit(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		e.preventDefault();

		// send the data to the parent
		props.requestMerge({
			mrgPhNo: mrgPhNo as string,
			mrgEml: mrgEml as string,
			mrgUid: mrgUid as string,
			mrgAccTyp: mrgAccDts.uids.find((uid: any) => uid.uid === mrgUid).accTyp
		});
	}

	function handleRemindLater(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		e.preventDefault();
		props.remindLater();
	}

	return (
		<form>
			{/* Show only if there are 2 uids present */}
			{mrgAccDts.uids.length > 1 && (
				<>
					<label className="inp_lbl mg-b20 ib">Select Preferred Login ID</label>
					<ul className="same_acc_radio mg-b40">
						<li className="list_Item">
							{mrgAccDts.uids.map((uid: any) => (
								<RadioButton
									key={uid.uid}
									list={{ display: uid.uid, value: uid.uid }}
									name="loginId"
									selected={mrgUid}
									onChange={() => setMrgUid(uid.uid)}
								/>
							))}
						</li>
					</ul>
				</>
			)}

			{/* Show only if there are 2 phNos present */}
			{mrgAccDts.phNos.length > 1 && (
				<>
					<label className="inp_lbl mg-b20 ib">Select contact number</label>
					<ul className="same_acc_radio mg-b40">
						<li className="list_Item">
							{mrgAccDts.phNos.map((phNo: string) => (
								<RadioButton
									key={phNo}
									list={{ display: "+91-" + phNo, value: phNo }}
									name="contact"
									selected={mrgPhNo}
									onChange={() => setMrgPhNo(phNo)}
								/>
							))}
						</li>
					</ul>
				</>
			)}

			{/* Show only if there are 2 emIds present */}
			{mrgAccDts.emIds.length > 1 && (
				<>
					<label className="inp_lbl mg-b20 ib">Select an email address</label>
					<ul className="same_acc_radio mg-b15">
						{mrgAccDts.emIds.map((emId: string) => (
							<li className="list_Item mg-b25" key={emId}>
								<RadioButton
									key={emId}
									list={{ display: emId, value: emId }}
									name="email"
									selected={mrgEml}
									onChange={() => setMrgEml(emId)}
								/>
							</li>
						))}
					</ul>
				</>
			)}

			<div className="buttons">
				<EdButton value="Not now" btnTyp="secondary" className="not_now_btn" type="button" onClick={handleRemindLater} />
				<EdButton
					value="Confirm and Merge"
					btnTyp="primary"
					className="submit_btn"
					type="submit"
					disabled={props.disableForm}
					onClick={handleSubmit}
				/>
			</div>
		</form>
	);
};

export default MergeIdForm;
